exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-container[data-v-600d8304] {\n  max-width: 300px;\n}\n", ""]);

// exports
